/** @jsx $mol_jsx */
namespace $.$$ {
	export class $mol_vary_edit_demo extends $.$mol_vary_edit_demo {
		
		@ $mol_mem
		dom() {
			return <div class="bar">hello <b>world</b></div>
		}
		
	}
}
